export default "__VITE_ASSET__c32ae9d0__"